var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBxSpreadsheet(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 3.33333C14 2.598 13.402 2 12.6667 2H3.33333C2.598 2 2 2.598 2 3.33333V12.6667C2 13.402 2.598 14 3.33333 14H12.6667C13.402 14 14 13.402 14 12.6667V3.33333ZM3.33333 12.6667V3.33333H12.6667L12.668 12.6667H3.33333Z",
    fill: "#A2A2A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.6665 4.66797H5.9985V6.0013H4.6665V4.66797ZM7.33317 4.66797H11.3332V6.0013H7.33317V4.66797ZM4.6665 7.33464H5.9985V8.66797H4.6665V7.33464ZM7.33317 7.33464H11.3332V8.66797H7.33317V7.33464ZM4.6665 10.0013H5.9985V11.3346H4.6665V10.0013ZM7.33317 10.0013H11.3332V11.3346H7.33317V10.0013Z",
    fill: "#A2A2A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxSpreadsheet);
export default __webpack_public_path__ + "static/media/bx-spreadsheet.886a9b7586a7df292351042e241bb809.svg";
export { ForwardRef as ReactComponent };